import tmdb from './client';

const fetchData = (page, config = {}) =>
  tmdb.get('/movie/now_playing', {
    ...config,
    params: { language: 'en-US', page, ...(config.params || {}) },
  });

export default fetchData;
